/* =========================================================
   세그먼트별 랜딩페이지 (/for/*) — 문구 · 데이터 단일 출처
   기획: tmp/imeta-landing-plan.md

   - LANDING_SEGMENTS 의 slug 가 주소가 된다 (/for/<slug>).
   - ready: true 인 세그먼트만 랜딩페이지가 열린다. 아직 준비 중인 분야는
     허브(/for)에서 바로 문의 페이지로 연결되고, 문의에 분야가 그대로 기록된다.
   - slug · 선택지 값은 백엔드 app/landing.py 와 글자 그대로 맞춰야 한다.
   - 사례는 I.META 이름으로 수행한 작업만 쓴다. 실적이 없는 분야의 examples 는
     '제작 예시'로만 보이고 실적처럼 쓰지 않는다.
   ========================================================= */

/* --------------------------------------------------------
   Terry 결정 대기 항목 — 정해지면 여기만 바꾼다
   -------------------------------------------------------- */
/* 옵션 A 페이지에 노출할 유튜브 채널 주소 — 비워 두면 링크를 숨긴다 */
export const YOUTUBE_URL = "";

/* 문의 후 연락까지 걸리는 영업일 — 자동 회신 메일(app/landing.py REPLY_DAYS)과 맞춘다 */
export const REPLY_DAYS = 2;

/* --------------------------------------------------------
   진행 옵션 A · B · C (가칭)
   -------------------------------------------------------- */
export const LANDING_OPTIONS = {
  A: {
    id: "A",
    name: "공개 제작형",
    cost: "재료비만",
    condition: "개발 전 과정을 I.META 유튜브 채널에 콘텐츠로 공개합니다.",
    fit: "예술 작품, 개인 1점 제작, 공방 오브제, 전시·체험 장치",
  },
  B: {
    id: "B",
    name: "제품화 파트너형",
    cost: "최소 개발비",
    condition:
      "양산에 들어가면 I.META가 양산을 맡습니다(또는 지분 참여). 미팅에서 양산 가능성을 함께 검토한 뒤 진행합니다.",
    fit: "아이디어 상품, 크라우드펀딩, 발명품, 실버·펫 용품",
  },
  C: {
    id: "C",
    name: "일반 개발형",
    cost: "정상 개발비 · 상담 후 견적",
    condition: "비공개로 진행하며 별도 조건이 없습니다.",
    fit: "정부지원사업 지원금 집행, 업체 의뢰, 기밀 유지가 필요한 개발",
  },
};
export const OPTION_ORDER = ["A", "B", "C"];

/* 옵션 A 를 추천하는 페이지의 계약 조건 요약 (공개 시점 · 공개 범위 · 크레딧).
   세그먼트에 options.terms 가 있으면 그 목록이 이 기본 문구를 대신한다. */
export const OPTION_A_TERMS = [
  "공개 시점은 고객 일정에 맞춰 조정할 수 있습니다.",
  "공개 범위(얼굴·장소·핵심 내용 등)는 미리 협의합니다.",
  "영상과 결과물에는 크레딧을 표기합니다.",
];

/* --------------------------------------------------------
   공통 — 진행 과정 · 강점
   -------------------------------------------------------- */
export const LANDING_PROCESS = [
  { title: "문의", desc: "아이디어를 편하게 남겨 주세요. 구체적이지 않아도 괜찮습니다." },
  { title: "상담 · 검토", desc: "서면으로 먼저 검토한 뒤 온라인 또는 광주 대면 미팅으로 이야기하고, 진행 옵션을 정합니다." },
  { title: "시제품 개발", desc: "회로·PCB·펌웨어·외형·서버/앱을 개발하며 중간 결과를 공유합니다." },
  { title: "납품", desc: "동작 확인을 마친 시제품과 필요한 자료를 전달합니다." },
  { title: "양산", desc: "판매할 제품이라면 소량 생산부터 양산까지 이어 갑니다.", optional: true },
];

/* 모든 페이지 하단 CTA 아래에 붙는 비밀 보장 문구 */
export const SECRET_NOTE =
  "아이디어 내용은 외부에 공개하지 않습니다. 필요하시면 상담 전에 비밀유지계약(NDA)을 맺습니다.";

/* 문의 폼 상단 안내 */
export const FORM_INTRO = "구체적이지 않아도 괜찮습니다. 아이디어 내용은 외부에 공개하지 않습니다.";

/* --------------------------------------------------------
   문의 폼 선택지 — 백엔드 app/landing.py 와 값이 일치해야 한다
   -------------------------------------------------------- */
export const LEAD_STAGES = ["아이디어만", "스케치·도면 있음", "시제품 있음", "판매 중"];
export const LEAD_OPTIONS = [
  ["A", "A · 공개 제작형 (재료비만)"],
  ["B", "B · 제품화 파트너형 (최소 개발비)"],
  ["C", "C · 일반 개발형 (비공개)"],
  ["?", "잘 모르겠음"],
];
export const LEAD_BUDGETS = [
  "아직 모르겠음",
  "100만원 미만",
  "100~500만원",
  "500~1,000만원",
  "1,000~3,000만원",
  "3,000만원 이상",
];
export const LEAD_QTYS = ["1개 (직접 사용)", "10개 미만", "10~100개", "100~1,000개", "1,000개 이상", "아직 모르겠음"];
export const LEAD_GOV = ["수행 중 (선정됨)", "신청 예정", "해당 없음"];
export const LEAD_VIDEO = ["가능", "일부만 가능", "어려움", "아직 모르겠음"];

/* --------------------------------------------------------
   세그먼트 15개
   no: 기획서 번호 · wave: 배포 차수 · icon: Icon.jsx 이름
   -------------------------------------------------------- */
const WHY_BASE = {
  oneStop: {
    icon: "Layers",
    title: "업체 여러 곳 대신, 한 곳에서",
  },
  career: {
    icon: "Award",
    title: "임베디드 개발 20년",
  },
  ai: {
    icon: "Brain",
    title: "AI 개발 도구로 빠르고 합리적으로",
  },
  local: {
    icon: "Globe",
    title: "광주 기반 · 전국 원격 진행",
  },
};

function why(key, desc) {
  return { ...WHY_BASE[key], desc };
}

export const LANDING_SEGMENTS = [
  /* ① 정부지원사업 선정자 · 초기 창업팀 ------------------------------ */
  {
    slug: "startup",
    no: 1,
    wave: 1,
    ready: true,
    icon: "Award",
    label: "정부지원사업 선정팀 · 초기 창업팀",
    who: "예비·초기창업패키지, 청년창업사관학교, 대학·지자체 지원 창업팀",
    seo: {
      title: "지원사업 시제품 개발 — 협약 기간 안에 시제품까지 | I.META",
      description:
        "지원금은 받았는데 개발할 사람이 없는 창업팀을 위해 회로·PCB·펌웨어·서버·앱까지 한 곳에서 개발합니다. 용역 계약서·세금계산서 발행.",
    },
    hero: {
      kicker: "정부지원사업 · 초기 창업팀",
      title: "지원사업 기간 안에,\n시제품까지 책임집니다",
      lead:
        "지원금은 확보했는데 개발할 사람이 없다면, 회로·PCB·펌웨어·서버·앱까지 한 곳에서 맡아 협약 기간 안에 동작하는 시제품을 만듭니다.",
    },
    pains: [
      {
        title: "지원금은 받았는데, 개발할 사람이 없습니다",
        desc: "팀에 하드웨어·펌웨어 개발자가 없어 사업비가 묶여 있습니다. 새로 뽑기엔 협약 기간이 너무 짧습니다.",
      },
      {
        title: "협약 기간 안에 시제품을 내야 합니다",
        desc: "중간 점검과 최종 보고 일정은 정해져 있는데, 어디서부터 시작해야 할지 막막합니다.",
      },
      {
        title: "외주 업체는 비싸고 느립니다",
        desc: "회로는 A사, 앱은 B사. 업체를 여러 곳 거치면 견적은 늘고 일정은 밀리고, 책임질 곳은 흐려집니다.",
      },
    ],
    solution: {
      title: "개발 조직이 없는 팀의\n개발팀이 되어 드립니다",
      items: [
        { icon: "Rocket", title: "일정부터 역산합니다", desc: "협약 종료일과 중간 점검 일정에 맞춰 개발 단계와 산출물을 먼저 정합니다." },
        { icon: "Layers", title: "회로부터 앱까지 한 창구", desc: "회로·PCB·펌웨어·서버·웹/앱을 나눠 맡기지 않아도 됩니다. 소통 창구가 하나입니다." },
        { icon: "Brain", title: "AI 개발 도구로 짧은 기간", desc: "반복 작업을 AI 개발 도구로 줄여, 짧은 협약 기간에 맞는 속도로 개발합니다." },
        { icon: "Doc", title: "보고에 쓸 기술 자료까지", desc: "회로도·개발 사진·동작 영상·기술 설명 등 중간·최종 보고에 필요한 기술 자료를 정리해 드립니다." },
      ],
    },
    options: {
      recommend: "C",
      reason: "지원금은 정상 용역 계약으로 집행하는 것이 깔끔합니다. 용역 계약서와 세금계산서를 발행합니다.",
      notes: { B: "지원사업 이후 양산까지 생각하고 있다면 제품화 파트너형도 함께 검토할 수 있습니다." },
    },
    examples: [
      { icon: "Sensor", title: "IoT 센서 디바이스", desc: "온도·습도·진동 등을 측정해 서버로 보내는 장치" },
      { icon: "Chip", title: "스마트 기기 시제품", desc: "핵심 기능이 실제로 동작하는 기기와 3D 프린팅 외형" },
      { icon: "Tablet", title: "앱 연동 하드웨어", desc: "블루투스·Wi-Fi로 스마트폰 앱과 연결되는 기기" },
      { icon: "Globe", title: "데모용 웹 대시보드", desc: "측정값과 기기 상태를 보여 주는 발표·시연용 웹 화면" },
    ],
    why: [
      why("oneStop", "회로설계 → PCB → 펌웨어 → 서버 → 웹/앱. 업체를 여러 곳 거치지 않으니 일정이 덜 밀립니다."),
      why("career", "20년 경력의 임베디드 개발자가 직접 설계하고 개발합니다. 중간에 담당자가 바뀌지 않습니다."),
      why("ai", "최신 AI 개발 도구로 개발 기간을 줄여, 협약 기간이 짧은 지원사업에도 맞출 수 있습니다."),
      why("local", "광주·전남 팀은 직접 만나서, 다른 지역은 온라인 미팅과 택배로 진행합니다."),
    ],
    faq: [
      { q: "용역 계약서와 세금계산서를 발행하나요?", a: "네. 사업자로서 용역 계약을 맺고 세금계산서를 발행합니다. 지원사업 집행에 필요한 견적서도 드립니다." },
      { q: "사업계획서에 적힌 일정에 맞출 수 있나요?", a: "협약 기간과 중간 점검 일정을 알려 주시면 그 일정에서 거꾸로 계산해 개발 단계와 산출물을 정합니다. 기간 안에 어려운 범위는 처음부터 솔직하게 말씀드립니다." },
      { q: "중간·최종 보고 자료도 도와주시나요?", a: "회로도, 개발 과정 사진·영상, 기술 설명 등 보고서에 들어갈 기술 자료를 정리해 드립니다. 보고서 작성은 팀에서 하시고 기술 부분을 지원하는 방식입니다." },
      { q: "광주가 아니어도 진행할 수 있나요?", a: "네. 상담과 중간 공유는 온라인으로 하고 시제품은 택배로 전달합니다. 광주·전남 지역은 직접 만나서 진행할 수도 있습니다." },
      { q: "특정 지원사업과 연계된 업체인가요?", a: "아닙니다. 특정 지원사업이나 기관과 제휴 관계는 없습니다. 지원금을 받은 팀이 직접 개발 용역 업체로 선정해 계약하는 일반적인 방식입니다." },
    ],
    cta: { title: "협약 기간이 줄어들기 전에,\n일정부터 맞춰 보세요" },
  },

  /* ② 크라우드펀딩 준비자 ------------------------------------------- */
  {
    slug: "funding",
    no: 2,
    wave: 2,
    icon: "Rocket",
    label: "크라우드펀딩 준비자",
    who: "와디즈·텀블벅에 전자 제품을 올리려는 개인·팀",
  },

  /* ③ 개인 발명가 · 특허 보유자 ------------------------------------- */
  {
    slug: "inventor",
    no: 3,
    wave: 2,
    icon: "Lightbulb",
    label: "개인 발명가 · 특허 보유자",
    who: "특허·실용신안을 가지고 있거나 출원을 준비 중인 개인",
  },

  /* ④ 아이디어 상품 개발자 · 온라인 셀러 ----------------------------- */
  {
    slug: "seller",
    no: 4,
    wave: 1,
    ready: true,
    icon: "Cart",
    label: "아이디어 상품 개발자 · 온라인 셀러",
    who: "생활 아이디어 제품 기획자, 스마트스토어·쿠팡 PB 상품을 만들고 싶은 셀러",
    seo: {
      title: "아이디어 상품 시제품 · 소량 생산 — 중국 OEM 전에 | I.META",
      description:
        "생활 아이디어 제품, 내 PB 상품을 국내에서 시제품부터 소량 생산까지. 회로·펌웨어·앱·3D 프린팅 외형을 한 곳에서 개발합니다.",
    },
    hero: {
      kicker: "아이디어 상품 · 온라인 셀러",
      title: "중국 공장에 맡기기 전에,\n먼저 제대로 만들어 보세요",
      lead:
        "생활 아이디어 제품, 스마트스토어·쿠팡에 올릴 내 상품. 동작하는 시제품부터 소량 생산까지 국내에서 함께 만듭니다.",
    },
    pains: [
      {
        title: "중국 OEM은 최소 수량부터 부담입니다",
        desc: "최소 주문 수천 개에 선금 결제. 시장 반응도 모르는 상태에서 재고부터 떠안게 됩니다.",
      },
      {
        title: "말이 잘 통하지 않습니다",
        desc: "원하는 기능을 설명해도 다른 물건이 오고, 수정 한 번에 몇 주가 지나갑니다.",
      },
      {
        title: "국내 개발은 너무 비쌉니다",
        desc: "디자인·회로·펌웨어를 따로 맡기면 견적이 순식간에 불어납니다.",
      },
    ],
    solution: {
      title: "작게 만들어 확인하고,\n팔리면 함께 키웁니다",
      items: [
        { icon: "Box", title: "동작하는 시제품부터", desc: "핵심 기능이 실제로 동작하는 시제품으로 상세페이지 촬영과 주변 반응을 먼저 확인합니다." },
        { icon: "Layers", title: "양산을 염두에 둔 설계", desc: "처음부터 부품 수급·단가·조립을 고려해 설계하므로, 양산 단계에서 다시 만들 일이 줄어듭니다." },
        { icon: "Cart", title: "소량 생산부터", desc: "수백 개 단위 소량 생산부터 시작해 판매 반응에 맞춰 수량을 늘립니다." },
        { icon: "Mail", title: "한국어로, 개발자와 직접", desc: "기획 의도를 개발자에게 직접 설명하고, 진행 상황을 바로 확인합니다." },
      ],
    },
    options: {
      recommend: "B",
      reason: "개발비는 최소로 낮추고, 제품이 팔려 양산에 들어가면 I.META가 양산을 맡는 방식입니다. 미팅에서 양산 가능성을 함께 검토한 뒤 진행합니다.",
    },
    examples: [
      { icon: "Plug", title: "소형 가전 아이디어 제품", desc: "기능 하나에 집중한 작은 생활 가전" },
      { icon: "Bolt", title: "충전식 생활기기", desc: "USB-C 충전 배터리를 넣은 휴대형 생활용품" },
      { icon: "Sensor", title: "센서 알림 장치", desc: "문 열림·물 넘침·자리 비움 등을 감지해 알려 주는 장치" },
      { icon: "Tablet", title: "앱 연동 소품", desc: "스마트폰 앱으로 켜고 끄고 설정하는 생활 소품" },
      { icon: "Box", title: "3D 프린팅 외형 시제품", desc: "상세페이지 촬영과 사용성 확인을 위한 외형 모델" },
    ],
    why: [
      why("oneStop", "회로·PCB·펌웨어·앱에 3D 모델링·3D 프린팅 외형까지. 시제품 하나를 위해 업체를 여러 곳 찾지 않아도 됩니다."),
      why("career", "20년 임베디드 개발 경험으로 '만들 수 있는 것'과 '양산할 수 있는 것'의 차이를 처음부터 고려합니다."),
      why("ai", "AI 개발 도구로 시제품까지 걸리는 시간과 비용을 줄입니다. 작게 시작하기 좋은 구조입니다."),
      why("local", "광주에서는 직접 만나 시제품을 보며 이야기하고, 다른 지역은 온라인과 택배로 진행합니다."),
    ],
    faq: [
      { q: "최소 몇 개부터 생산할 수 있나요?", a: "제품에 따라 다르지만 수백 개 단위 소량 생산부터 상담할 수 있습니다. 수량이 늘수록 단가가 내려가므로, 시제품 단계에서 수량별 예상 단가를 함께 정리해 드립니다." },
      { q: "KC 인증도 해 주시나요?", a: "인증 대행은 하지 않습니다. 제품에 필요할 수 있는 인증 종류를 안내하고 인증을 고려해 설계합니다. 인증 시험은 고객이 시험기관에 직접 의뢰하시게 됩니다." },
      { q: "양산 단가는 언제 알 수 있나요?", a: "시제품을 만들면서 부품과 구조가 정해지면 예상 양산 단가를 산정합니다. 아이디어 단계에서는 대략적인 범위만 말씀드릴 수 있습니다." },
      { q: "제품화 파트너형은 어떤 조건인가요?", a: "I.META가 개발비 부담을 줄여 드리는 대신, 양산에 들어가면 양산을 I.META가 맡는 조건입니다. 그래서 미팅에서 양산 가능성을 먼저 검토하고, 맞지 않으면 일반 개발형으로 안내해 드립니다." },
      { q: "제 아이디어가 다른 곳에 팔리지는 않나요?", a: "제품 아이디어와 브랜드는 고객의 것입니다. 상담 내용은 외부에 공개하지 않으며, 필요하시면 상담 전에 비밀유지계약(NDA)을 맺습니다." },
    ],
    cta: { title: "최소 수량 걱정 없이,\n시제품부터 시작해 보세요" },
  },

  /* ⑤ 카페 · 음식점 · 소상공인 --------------------------------------- */
  {
    slug: "store",
    no: 5,
    wave: 2,
    icon: "Tablet",
    label: "카페 · 음식점 · 소상공인",
    who: "매장에 딱 맞는 장비가 필요한 자영업자",
  },

  /* ⑥ 반려동물 용품 사업자 ------------------------------------------- */
  {
    slug: "pet",
    no: 6,
    wave: 3,
    icon: "Pulse",
    label: "반려동물 용품 사업자",
    who: "펫 용품 브랜드, 펫 용품 창업 준비자",
  },

  /* ⑦ 개인 공방 ------------------------------------------------------- */
  {
    slug: "workshop",
    no: 7,
    wave: 2,
    icon: "Wrench",
    label: "개인 공방",
    who: "목공·조명·가죽·캔들·플라워·도자 공방",
  },

  /* ⑧ 예술 작가 ------------------------------------------------------- */
  {
    slug: "artist",
    no: 8,
    wave: 1,
    ready: true,
    icon: "Motion",
    label: "예술 작가 (미디어·키네틱·설치)",
    who: "움직임·빛·센서 반응이 필요한 작품을 하는 작가",
    seo: {
      title: "키네틱·미디어아트 기술 구현 — 재료비만으로 | I.META",
      description:
        "모터·조명·센서가 들어가는 작품의 기술 구현을 맡습니다. 제작 과정을 영상으로 공개하는 조건이면 재료비만 받습니다. 공개는 전시 오픈 이후.",
    },
    hero: {
      kicker: "미디어아트 · 키네틱아트 · 설치미술",
      title: "작가님의 상상은 그대로,\n움직이는 건 저희가",
      lead:
        "모터·조명·센서가 들어가는 작품의 기술 구현을 맡습니다. 제작 과정을 영상으로 공개하는 조건이면 재료비만 받습니다.",
    },
    pains: [
      {
        title: "구현해 줄 기술자가 없습니다",
        desc: "머릿속엔 움직임과 빛이 그려지는데, 모터·센서·제어를 맡아 줄 사람을 찾기 어렵습니다.",
      },
      {
        title: "전시 일정은 다가옵니다",
        desc: "오프닝 날짜는 정해져 있고, 시행착오를 반복할 시간이 없습니다.",
      },
      {
        title: "예산이 작습니다",
        desc: "지원금과 자부담으로 꾸리는 작업이라 기술 외주에 큰 비용을 쓰기 어렵습니다.",
      },
    ],
    solution: {
      title: "작가는 작품에,\n기술은 I.META에",
      items: [
        { icon: "Lightbulb", title: "콘셉트를 기술로 옮깁니다", desc: "스케치나 레퍼런스 영상이면 충분합니다. 원하는 움직임과 반응을 듣고 구현 방법을 제안합니다." },
        { icon: "Rocket", title: "전시 일정에 맞춘 개발", desc: "오프닝 날짜에서 거꾸로 계산해 제작·테스트·설치 일정을 잡습니다." },
        { icon: "Shield", title: "전시 기간 무인 운영", desc: "하루 종일 켜 두어도 멈추지 않도록 안정성과 자동 복구를 고려해 만듭니다." },
        { icon: "Award", title: "재료비만으로", desc: "제작 과정을 콘텐츠로 공개하는 공개 제작형이면 재료비만 부담하시면 됩니다." },
      ],
    },
    options: {
      recommend: "A",
      reason: "제작 과정을 I.META 유튜브 채널에 공개하는 조건으로, 개발비 없이 재료비만 받습니다.",
      terms: [
        "영상 공개는 전시 오픈 이후로 맞추고, 전시 홍보 시기에 맞춰 공개 시점을 정할 수 있습니다.",
        "작품의 핵심 장면 등 공개 범위는 미리 협의합니다.",
        "크레딧은 '콘셉트·디자인: 작가, 기술 구현: I.META' 형태로 협의합니다.",
      ],
      notes: { C: "공개가 어려운 작품은 비공개 일반 개발형으로 진행합니다." },
    },
    examples: [
      { icon: "Motion", title: "키네틱 조형물 모터 제어", desc: "정해진 안무처럼 움직이는 조형물의 모터 구동과 제어" },
      { icon: "Sensor", title: "관객 반응 센서 작품", desc: "다가가거나 만지면 반응하는 작품" },
      { icon: "Lightbulb", title: "빛·소리 연동 설치물", desc: "조명과 사운드가 함께 움직이는 설치 작품" },
      { icon: "Layers", title: "다축 모터 제어 시스템", desc: "여러 개의 모터를 맞춰 움직이는 대형 작품의 제어부" },
      { icon: "Pulse", title: "원격 상태 확인", desc: "전시장 밖에서도 작품이 잘 돌고 있는지 확인하는 기능" },
    ],
    why: [
      why("oneStop", "회로부터 제어 소프트웨어까지 한 사람이 만들기 때문에, 전시장에서 문제가 생겨도 원인을 빨리 찾습니다."),
      why("career", "모터·센서·조명 제어는 20년 임베디드 개발의 본업입니다."),
      { icon: "Box", title: "기구 부품도 직접 출력", desc: "3D 모델링·3D 프린팅으로 브래킷과 기구 부품을 직접 만들어 작품에 맞춥니다." },
      why("local", "광주·전남 전시는 설치 현장 동행을 협의할 수 있고, 다른 지역은 원격으로 지원합니다."),
    ],
    faq: [
      { q: "전시 중에 고장 나면 어떻게 하나요?", a: "원격으로 상태를 확인할 수 있게 만들고, 문제가 생기면 원격 점검부터 합니다. 광주·전남 지역 전시는 현장 방문도 협의할 수 있습니다. 전시 기간 중 대응 범위는 계약 때 정합니다." },
      { q: "작품 저작권은 누구에게 있나요?", a: "작품의 저작권은 작가님께 있습니다. I.META는 기술 구현 크레딧만 표기하며, 표기 방식은 협의합니다." },
      { q: "제작 영상은 언제, 어디까지 공개되나요?", a: "전시 오픈 이후 공개하는 것이 기본입니다. 작품의 핵심 장면처럼 공개를 원하지 않는 부분은 미리 협의해 제외합니다." },
      { q: "재전시할 때 유지보수도 해 주시나요?", a: "네. 재전시 전 점검, 부품 교체, 설정 변경을 도와드립니다. 비용은 작업 범위에 따라 협의합니다." },
      { q: "공개가 어려운 작품도 가능한가요?", a: "가능합니다. 일반 개발형(비공개)으로 진행하면 영상 공개 조건 없이 정상 개발비로 진행합니다." },
    ],
    cta: { title: "다음 전시의 움직임,\n지금 이야기해 주세요" },
  },

  /* ⑨ 전시 · 체험 연출업체 / 인테리어 업체 ---------------------------- */
  {
    slug: "exhibit",
    no: 9,
    wave: 3,
    icon: "Sensor",
    label: "전시 · 체험 연출 · 인테리어 업체",
    who: "박물관·과학관·체험관 전시물 업체, 키즈카페, 상업 인테리어 업체",
  },

  /* ⑩ 간판 · 광고판 · 매장 디스플레이 제작업자 ------------------------ */
  {
    slug: "signage",
    no: 10,
    wave: 2,
    icon: "Bolt",
    label: "간판 · 광고판 · 디스플레이 제작업체",
    who: "간판 제작업체, POP·디스플레이 업체, 팝업스토어 기획사",
  },

  /* ⑪ 요양 · 실버 용품 사업자 ---------------------------------------- */
  {
    slug: "silver",
    no: 11,
    wave: 1,
    ready: true,
    icon: "Shield",
    label: "요양 · 실버 용품 사업자",
    who: "실버 용품 사업자, 요양시설 대상 제품 기획자, 고령화 관련 창업자",
    seo: {
      title: "실버 · 돌봄 전자 제품 개발 — 쓰기 쉬운 기기 | I.META",
      description:
        "큰 버튼·음성 안내·보호자 알림까지. 어르신과 돌봄 현장에 맞춘 생활 보조 전자 제품을 시제품부터 양산까지 함께 만듭니다.",
    },
    hero: {
      kicker: "요양 · 실버 용품",
      title: "어르신이 쓰기 쉬운 전자 제품,\n함께 만듭니다",
      lead:
        "버튼은 크게, 동작은 단순하게, 보호자에게는 알림이 가도록. 어르신의 생활에 맞춘 전자 제품을 시제품부터 양산까지 만듭니다.",
    },
    pains: [
      {
        title: "단순하고 안전해야 합니다",
        desc: "기능이 많을수록 어르신은 쓰지 않습니다. 버튼 하나, 소리 하나까지 신경 써야 합니다.",
      },
      {
        title: "맞는 개발처를 찾기 어렵습니다",
        desc: "규모가 작은 기획을 시제품부터 함께 만들어 줄 곳이 마땅치 않습니다.",
      },
      {
        title: "보호자 연동까지 붙으면 복잡해집니다",
        desc: "기기에 앱·서버·알림까지 붙어야 해서 여러 업체를 거쳐야 합니다.",
      },
    ],
    solution: {
      title: "쓰는 분에 맞춰 단순하게,\n연결은 빠짐없이",
      items: [
        { icon: "Tablet", title: "사용 장면부터 설계", desc: "큰 버튼, 음성 안내, 불빛 표시. 누가 어디서 쓰는지부터 정하고 기능을 덜어 냅니다." },
        { icon: "Server", title: "보호자 알림까지 한 번에", desc: "기기, 서버, 보호자 알림 화면을 한 곳에서 개발합니다." },
        { icon: "Search", title: "시제품으로 먼저 확인", desc: "시제품을 시설이나 가정에서 먼저 써 보고, 불편한 점을 고친 뒤 양산합니다." },
        { icon: "Rocket", title: "양산까지 이어서", desc: "제품화 파트너형으로 개발비 부담을 줄이고 양산까지 함께 갑니다." },
      ],
    },
    options: {
      recommend: "B",
      reason: "판매할 제품이라면 개발비를 최소로 하고, 양산에 들어가면 I.META가 양산을 맡는 제품화 파트너형을 권합니다. 미팅에서 양산 가능성을 함께 검토합니다.",
    },
    examples: [
      { icon: "Box", title: "복약 알림 약 보관함", desc: "정해진 시간에 불빛과 소리로 알리고, 열지 않으면 보호자에게 알리는 보관함" },
      { icon: "Sensor", title: "움직임 감지 알림", desc: "넘어짐이 의심되거나 오래 움직임이 없으면 보호자에게 알리는 장치" },
      { icon: "Phone", title: "보호자 호출 장치", desc: "버튼 한 번으로 보호자에게 알림을 보내는 장치" },
      { icon: "Tablet", title: "큰 버튼·음성 안내 기기", desc: "글자 대신 큰 버튼과 음성으로 쓰는 생활 기기" },
      { icon: "Globe", title: "보호자·시설용 상태 화면", desc: "여러 기기의 알림과 상태를 한 화면에서 확인하는 웹" },
    ],
    why: [
      why("oneStop", "기기 회로·펌웨어부터 알림 서버·보호자 화면까지 한 곳에서 만들어, 연동 문제를 줄입니다."),
      why("career", "20년 임베디드 개발 경험으로, 오래 켜 두어도 안정적으로 동작하는 기기를 만듭니다."),
      why("ai", "AI 개발 도구로 시제품을 빠르게 만들어 현장 의견을 일찍 반영합니다."),
      why("local", "광주·전남 시설과는 직접 만나 현장을 보며 이야기할 수 있습니다."),
    ],
    faq: [
      { q: "의료기기도 개발하나요?", a: "아닙니다. 의료기기 인증이 필요한 제품은 진행 범위에서 제외합니다. 생활 보조·알림·편의를 위한 제품을 만들며, 진단이나 치료 효과를 내세우는 제품은 다루지 않습니다." },
      { q: "보호자 스마트폰으로 알림을 받을 수 있나요?", a: "네. 문자, 앱 푸시, 웹 화면 등 방식은 제품의 사용 환경과 예산에 맞춰 정합니다." },
      { q: "소량만 먼저 만들어 써 볼 수 있나요?", a: "시제품 몇 대를 만들어 시설이나 가정에서 먼저 써 보는 방식을 권합니다. 반응을 보고 양산 여부를 정할 수 있습니다." },
      { q: "판매하려면 인증이 필요한가요?", a: "전자 제품은 판매 전에 KC 인증 등이 필요할 수 있습니다. I.META는 인증 대행은 하지 않지만, 필요한 인증 종류를 안내하고 인증을 고려해 설계합니다." },
      { q: "아이디어가 외부로 새지 않을까요?", a: "상담 내용은 외부에 공개하지 않습니다. 필요하시면 상담 전에 비밀유지계약(NDA)을 맺습니다." },
    ],
    cta: { title: "어르신의 하루를 편하게 할 아이디어,\n함께 다듬어 보세요" },
  },

  /* ⑫ 스마트팜 소농 · 귀농인 ------------------------------------------ */
  {
    slug: "farm",
    no: 12,
    wave: 3,
    icon: "Sensor",
    label: "스마트팜 소농 · 귀농인",
    who: "소규모 농가, 귀농·귀촌인, 수경재배·식물 키트 판매자",
  },

  /* ⑬ 교육업체 · 교구 제작자 ------------------------------------------ */
  {
    slug: "edu",
    no: 13,
    wave: 3,
    icon: "Doc",
    label: "교육업체 · 교구 제작자",
    who: "코딩·로봇·과학 교육업체, 방과후 강사, 교구 판매자",
  },

  /* ⑭ 개인 1점 제작 (본인 사용) --------------------------------------- */
  {
    slug: "personal",
    no: 14,
    wave: 1,
    ready: true,
    icon: "Lightbulb",
    label: "나만의 장치가 필요한 개인",
    who: "'이런 장치 하나 있으면 좋겠다' 싶은 개인, 취미인",
    seo: {
      title: "나만의 장치 1점 제작 — 재료비만으로 | I.META",
      description:
        "세상에 없는 그 물건, 만드는 과정을 I.META 유튜브에 공개하는 조건으로 재료비만 받고 만들어 드립니다. 얼굴·집 공개 여부는 직접 선택.",
    },
    hero: {
      kicker: "나만의 장치 하나",
      title: "세상에 없는 그 물건,\n재료비만으로 만들어 드립니다",
      lead:
        "'이런 장치 하나 있으면 좋겠다' 싶었던 것. 만드는 과정을 I.META 유튜브에 공개하는 조건으로 재료비만 받고 만들어 드립니다.",
    },
    pains: [
      {
        title: "파는 곳이 없습니다",
        desc: "찾아봐도 딱 맞는 제품이 없거나, 있어도 해외 직구로만 구할 수 있습니다.",
      },
      {
        title: "어디에 부탁해야 할지 모릅니다",
        desc: "개발 업체는 개인 의뢰를 잘 받지 않고, 받아도 견적이 부담스럽습니다.",
      },
      {
        title: "직접 만들기엔 막막합니다",
        desc: "강좌를 봐도 회로·코딩·케이스까지 혼자 해내기는 쉽지 않습니다.",
      },
    ],
    solution: {
      title: "만드는 과정을 공유해 주시면,\n비용은 재료비만",
      items: [
        { icon: "Lightbulb", title: "아이디어 한 줄이면 충분합니다", desc: "그림 한 장, 말 몇 마디로 설명해 주셔도 됩니다. 구체화는 함께 합니다." },
        { icon: "Award", title: "재료비만 부담", desc: "개발비 대신 제작 과정을 I.META 유튜브 콘텐츠로 공개합니다." },
        { icon: "Shield", title: "얼굴·집 공개는 선택", desc: "영상에 무엇이 나올지는 고객이 정합니다. 장치만 촬영할 수도 있습니다." },
        { icon: "Box", title: "케이스까지 완성품으로", desc: "3D 모델링·3D 프린팅 케이스까지 씌워 바로 쓸 수 있게 드립니다." },
      ],
    },
    options: {
      recommend: "A",
      reason: "제작 과정을 I.META 유튜브 채널에 공개하는 조건으로, 개발비 없이 재료비만 받습니다.",
      terms: [
        "공개 시점은 고객 일정에 맞춰 조정할 수 있습니다.",
        "얼굴·목소리·집 내부가 나올지는 고객이 선택합니다.",
        "영상과 결과물에는 I.META 제작 크레딧을 표기합니다.",
      ],
      notes: { C: "공개가 어려운 장치는 비공개 일반 개발형으로 진행할 수 있습니다." },
    },
    examples: [
      { icon: "Motion", title: "취미용 제어 장치", desc: "캠핑·사진·모형·낚시 등 취미에 쓰는 맞춤 장치" },
      { icon: "Tablet", title: "맞춤 시계·디스플레이", desc: "원하는 정보를 원하는 모양으로 보여 주는 탁상 시계·전광판" },
      { icon: "Plug", title: "집안 자동화 소품", desc: "조명·환기·커튼을 시간이나 조건에 맞춰 움직이는 장치" },
      { icon: "Wrench", title: "수리 · 개조", desc: "단종된 기기를 고치거나 기능을 덧붙이는 개조" },
      { icon: "Sensor", title: "식물·수조 관리 장치", desc: "물 주기·조명·수온을 자동으로 관리하는 장치" },
    ],
    why: [
      why("oneStop", "회로부터 펌웨어, 앱, 케이스까지. 부품만 사다 놓고 멈출 일이 없습니다."),
      why("career", "20년 임베디드 개발 경험으로, 한 번 쓰고 마는 장난감이 아니라 오래 쓰는 장치를 만듭니다."),
      why("ai", "AI 개발 도구로 개발 시간을 줄여, 1점 제작도 부담 없이 진행합니다."),
      why("local", "광주에서는 직접 만나 전달하고, 다른 지역은 택배로 보내 드립니다."),
    ],
    faq: [
      { q: "정말 재료비만 내면 되나요?", a: "네. 공개 제작형은 부품·재료·3D 프린팅 재료비만 받습니다. 대신 제작 과정을 I.META 유튜브 채널에 공개합니다. 재료비는 시작 전에 예상 금액을 알려 드립니다." },
      { q: "어떤 아이디어든 다 만들어 주시나요?", a: "모든 요청을 진행하지는 못합니다. 제작 난이도, 콘텐츠로서의 의미, 일정 등을 보고 진행 여부를 알려 드립니다. 어려운 경우 이유와 다른 방법을 함께 말씀드립니다." },
      { q: "제 얼굴이나 집이 영상에 나오나요?", a: "고객이 선택합니다. 얼굴·목소리·집 내부를 빼고 장치만 촬영할 수도 있습니다." },
      { q: "얼마나 걸리나요?", a: "장치의 복잡도에 따라 다릅니다. 공개 제작형은 콘텐츠 촬영 일정과 함께 잡기 때문에, 일반 의뢰보다 일정을 여유 있게 잡아 주시면 좋습니다." },
      { q: "사용하다 고장 나면 어떻게 하나요?", a: "제작 전에 수리 범위와 방법을 함께 정합니다. 사용 중 문제가 생기면 먼저 연락 주세요." },
    ],
    cta: { title: "있으면 좋겠다 싶었던 그 장치,\n말씀만 해 주세요" },
  },

  /* ⑮ 소규모 제조업체 · 시설관리 업체 --------------------------------- */
  {
    slug: "factory",
    no: 15,
    wave: 3,
    icon: "Wrench",
    label: "소규모 제조 · 시설관리 업체",
    who: "전자 개발 인력이 없는 소규모 공장, 건물·시설관리 업체",
  },

  /* ⑯ 자영업 · 소상공인 홈페이지 (제품 개발이 아닌 웹사이트 구축) --------
     kind: "website" — 페이지 · 문의 폼 문구가 따로 있다 (website.js · WebsiteLanding.jsx).
     허브의 분야 목록 · 제품 개발 문의 폼의 분야 선택지에서는 빠지고 따로 안내한다. */
  {
    slug: "website",
    no: 16,
    wave: 1,
    ready: true,
    kind: "website",
    icon: "Globe",
    label: "자영업 · 소상공인 홈페이지",
    who: "식당 · 카페 · 미용실 · 공방 · 학원 등 가게 사장님",
    ctaLabel: "홈페이지 상담 문의하기",
  },
];

/* 제품 개발 세그먼트만 — 허브 목록 · 제품 개발 문의 폼 분야 선택지 */
export const PRODUCT_SEGMENTS = LANDING_SEGMENTS.filter((s) => s.kind !== "website");

export const SEGMENT_BY_SLUG = Object.fromEntries(LANDING_SEGMENTS.map((s) => [s.slug, s]));

/* 문의 페이지 주소 — 어느 세그먼트에서 왔는지 from 으로 넘긴다 */
export function contactLink(slug) {
  return slug ? `/for/contact?from=${slug}` : "/for/contact";
}

/* --------------------------------------------------------
   유입 추적 — 홍보물 형태(utm_medium) 표준 값
   SSTOA '랜딩 유입' 화면의 링크 만들기 선택지로 쓴다.
   -------------------------------------------------------- */
export const PROMO_MEDIUMS = [
  ["community", "커뮤니티 게시글"],
  ["cardnews", "카드뉴스"],
  ["blog", "블로그"],
  ["message", "짧은 메시지 (DM·메일·오픈채팅)"],
  ["shorts", "쇼츠 · 릴스"],
  ["etc", "기타"],
];

/* 유입 채널(utm_source) 예시 — 자유 입력이지만 이름을 맞춰 써야 통계가 모인다 */
export const PROMO_SOURCES = [
  "naver-cafe", "naver-blog", "instagram", "linkedin", "disquiet", "openchat",
  "youtube", "daangn", "email", "kakao", "facebook", "threads",
];
